<div *ngIf="init">
  <button
    (click)="openTab(tab)"
    mat-flat-button
    class="btn-gray"
    *ngFor="let tab of tabs"
    [ngClass]="{ active: projectTabsService.getActiveTab() === tab }"
  >
    {{ tab.title }}
  </button>
  <button
    *ngIf="inputProject.id != null"
    mat-flat-button
    [matMenuTriggerFor]="subProjectMenu"
    class="btn-gray"
  >
    <mat-icon svgIcon="add" class="add-tab-button"></mat-icon>
  </button>
  <mat-menu class="menu menu-width" #subProjectMenu="matMenu" xPosition="after">
    <button mat-menu-item (click)="addAdjustment.emit()">
      Aanpassing
    </button>
    <button mat-menu-item (click)="addSoldRented.emit()">
      Verkocht/Verhuurd
    </button>
    <button mat-menu-item (click)="addRepo.emit()">
      Weghalen
    </button>
  </mat-menu>
</div>
